import { AppAlert } from '../../services/AppAlert';
import appAnalytics from '../../services/appAnalytics';
import { buildAppAnalyticsContext } from '../../services/appAnalyticsContext';

/**
 * Leave the nested Demo stack and land on Auth `Onboarding` (WelcomeScreen).
 * Same parent-navigation pattern as `DemoCheckoutScreen` `handleBackToShop`,
 * but targets onboarding entry instead of `OnboardingCarousel`.
 */
export function navigateFromDemoToOnboarding(navigation: any): void {
  const parentNavigation = navigation.getParent?.();
  if (parentNavigation?.replace) {
    parentNavigation.replace('Onboarding');
    return;
  }
  if (parentNavigation?.navigate) {
    parentNavigation.navigate('Onboarding');
    return;
  }
  navigation.replace?.('DemoIntro');
}

/** Uses AppAlert so native gets RN Alert and web gets AppAlertHost Paper dialog. */
export function confirmQuitDemoAndGoToOnboarding(navigation: any): void {
  AppAlert.alert('Quit demo?', 'Are you sure you want to leave the demo?', [
    { text: 'Cancel', style: 'cancel' },
    {
      text: 'Quit',
      style: 'destructive',
      onPress: () => {
        const ctx = buildAppAnalyticsContext();
        appAnalytics.track('demo_quit', { ...ctx });
        navigateFromDemoToOnboarding(navigation);
      },
    },
  ]);
}
